/* =====================================================================
   Fann Bliss — World Cup Mugs Landing Page  (vanilla JS, no deps)
   ===================================================================== */
(function () {
  "use strict";

  var root = document.querySelector(".wc-page");
  if (!root) return;

  /* ---------- Config ---------- */
  var cfg = {};
  try {
    var cfgEl = document.getElementById("wc-config");
    if (cfgEl) cfg = JSON.parse(cfgEl.textContent);
  } catch (e) { cfg = {}; }
  var CART_ADD = cfg.cartAddUrl || "/cart/add.js";
  var CART_URL = cfg.cartUrl || "/cart";
  var CART_JS = (cfg.cartUrl || "/cart") + ".js";
  var CURRENCY = cfg.currency || "AED";
  var MSG_ADDED = cfg.addedMsg || "Added to cart";
  var MSG_ADDED_SUFFIX = cfg.addedSuffix || " added to cart";
  var LBL_VIEWCART = cfg.viewCartLabel || "View cart";
  var TOAST_POS = cfg.toastPos || "bottom-center";

  var products = Array.isArray(cfg.products) ? cfg.products : [];
  var productByVariant = {};
  products.forEach(function (p) { productByVariant[String(p.variantId)] = p; });

  function stockOf(vid) {
    var p = productByVariant[String(vid)];
    return (p && typeof p.stock === "number") ? p.stock : 9999;
  }

  function money(amount) {
    var n = Number(amount);
    if (isNaN(n)) return CURRENCY + " " + amount;
    var v = n % 1 === 0 ? n.toFixed(0) : n.toFixed(2);
    return CURRENCY + " " + v;
  }

  /* ---------- Toasts ---------- */
  var toastWrap = document.querySelector(".wc-toasts");
  if (!toastWrap) {
    toastWrap = document.createElement("div");
    toastWrap.className = "wc-toasts" + (TOAST_POS !== "bottom-center" ? " wc-toasts--" + TOAST_POS : "");
    toastWrap.setAttribute("aria-live", "polite");
    document.body.appendChild(toastWrap);
  }
  function toast(msg, type, withCartLink) {
    var t = document.createElement("div");
    t.className = "wc-toast" + (type ? " wc-toast--" + type : "");
    t.setAttribute("role", "status");
    var span = document.createElement("span");
    span.textContent = msg;
    t.appendChild(span);
    if (withCartLink) {
      var a = document.createElement("a");
      a.href = CART_URL; a.textContent = LBL_VIEWCART;
      t.appendChild(a);
    }
    toastWrap.appendChild(t);
    requestAnimationFrame(function () { t.classList.add("is-show"); });
    setTimeout(function () {
      t.classList.remove("is-show");
      setTimeout(function () { t.remove(); }, 300);
    }, 4200);
  }

  /* ---------- Cart count ---------- */
  function refreshCartCount() {
    fetch(CART_JS, { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-wc-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? "" : "none";
        });
      }).catch(function () {});
  }

  function addToCart(items) {
    // items: array of {id, quantity, properties}
    return fetch(CART_ADD, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw d; });
      return r.json();
    });
  }

  /* ---------- Smooth scroll ---------- */
  function scrollToId(id) {
    var el = document.getElementById(id);
    if (!el) return;
    var headerH = getStickyOffset();
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerH - 8;
    window.scrollTo({ top: top, behavior: "smooth" });
  }
  function getStickyOffset() {
    var h = document.querySelector(".wc-header--sticky");
    var c = document.querySelector(".wc-chips-wrap--sticky");
    return (h ? h.offsetHeight : 0) + (c ? c.offsetHeight : 0);
  }

  document.addEventListener("click", function (e) {
    var a = e.target.closest("[data-wc-scroll]");
    if (a) {
      e.preventDefault();
      scrollToId(a.getAttribute("data-wc-scroll"));
      closeDrawer();
    }
  });

  /* ---------- Mobile drawer ---------- */
  var drawer = document.querySelector(".wc-drawer");
  var drawerOverlay = document.querySelector(".wc-drawer-overlay");
  var lastFocus = null;
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add("is-open");
    if (drawerOverlay) drawerOverlay.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    var f = drawer.querySelector("button, a"); if (f) f.focus();
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains("is-open")) return;
    drawer.classList.remove("is-open");
    if (drawerOverlay) drawerOverlay.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    if (lastFocus) lastFocus.focus();
  }
  document.querySelectorAll("[data-wc-drawer-open]").forEach(function (b) { b.addEventListener("click", openDrawer); });
  document.querySelectorAll("[data-wc-drawer-close]").forEach(function (b) { b.addEventListener("click", closeDrawer); });
  if (drawerOverlay) drawerOverlay.addEventListener("click", closeDrawer);

  /* ---------- Chips active state via IntersectionObserver ---------- */
  var chips = Array.prototype.slice.call(document.querySelectorAll(".wc-chip[data-wc-target]"));
  if (chips.length && "IntersectionObserver" in window) {
    var targets = {};
    chips.forEach(function (c) {
      var id = c.getAttribute("data-wc-target");
      var sec = document.getElementById(id);
      if (sec) targets[id] = c;
    });
    var visible = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { visible[en.target.id] = en.isIntersecting ? en.intersectionRatio : 0; });
      var bestId = null, best = 0;
      Object.keys(visible).forEach(function (id) { if (visible[id] > best) { best = visible[id]; bestId = id; } });
      if (bestId) {
        chips.forEach(function (c) { c.classList.toggle("is-active", c.getAttribute("data-wc-target") === bestId); });
        var active = targets[bestId];
        if (active && active.parentNode) {
          var pl = active.offsetLeft - active.parentNode.offsetLeft;
          active.parentNode.scrollTo({ left: pl - 16, behavior: "smooth" });
        }
      }
    }, { rootMargin: "-45% 0px -50% 0px", threshold: [0, 0.25, 0.5, 1] });
    Object.keys(targets).forEach(function (id) { io.observe(document.getElementById(id)); });
  }

  /* ---------- Show more / less ---------- */
  document.querySelectorAll("[data-wc-showmore]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var grid = document.getElementById(btn.getAttribute("data-wc-showmore"));
      if (!grid) return;
      var expanded = grid.classList.toggle("is-expanded");
      btn.textContent = expanded ? (btn.getAttribute("data-less") || "Show Less")
                                  : (btn.getAttribute("data-more") || "Show More");
      btn.setAttribute("aria-expanded", expanded ? "true" : "false");
    });
  });

  /* ---------- FAQ accordion ---------- */
  var faqSingle = root.getAttribute("data-wc-faq-single") === "true";
  document.querySelectorAll(".wc-faq__q").forEach(function (q) {
    q.addEventListener("click", function () {
      var item = q.closest(".wc-faq__item");
      var ans = item.querySelector(".wc-faq__a");
      var isOpen = item.classList.contains("is-open");
      if (faqSingle) {
        document.querySelectorAll(".wc-faq__item.is-open").forEach(function (o) {
          if (o !== item) { o.classList.remove("is-open"); o.querySelector(".wc-faq__a").style.maxHeight = null; o.querySelector(".wc-faq__q").setAttribute("aria-expanded", "false"); }
        });
      }
      item.classList.toggle("is-open", !isOpen);
      q.setAttribute("aria-expanded", !isOpen ? "true" : "false");
      ans.style.maxHeight = !isOpen ? ans.scrollHeight + "px" : null;
    });
  });

  /* ---------- Single product add-to-cart ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-wc-add]");
    if (!btn) return;
    e.preventDefault();
    if (btn.dataset.loading === "1") return;
    var variantId = btn.getAttribute("data-wc-variant");
    if (!variantId) { toast("This mug is unavailable right now.", "error"); return; }
    setBtnLoading(btn, true);
    addToCart([{ id: Number(variantId), quantity: 1 }])
      .then(function () {
        refreshCartCount();
        toast(MSG_ADDED, "success", true);
      })
      .catch(function () { toast("Couldn’t add to cart. Please try again.", "error"); })
      .finally(function () { setBtnLoading(btn, false); });
  });

  function setBtnLoading(btn, on) {
    if (on) {
      btn.dataset.loading = "1";
      btn.dataset.label = btn.innerHTML;
      btn.innerHTML = '<span class="wc-spin"></span>';
      btn.setAttribute("aria-busy", "true");
      btn.disabled = true;
    } else {
      btn.dataset.loading = "0";
      if (btn.dataset.label) btn.innerHTML = btn.dataset.label;
      btn.removeAttribute("aria-busy");
      btn.disabled = false;
    }
  }

  /* ===================================================================
     BUNDLE BUILDER
     =================================================================== */
  var modal = document.querySelector(".wc-bundle-builder");
  var modalOverlay = document.querySelector(".wc-bundle-overlay");
  var state = { open: false, bundle: null, selection: {}, lastFocus: null };

  function eligibleProducts(handlesStr) {
    if (!handlesStr) return products.slice();
    var set = handlesStr.split(",").map(function (s) { return s.trim(); }).filter(Boolean);
    if (!set.length) return products.slice();
    var map = {};
    products.forEach(function (p) { map[p.handle] = p; });
    var out = [];
    set.forEach(function (h) { if (map[h]) out.push(map[h]); });
    // include any remaining products not explicitly listed? keep only listed for builder
    return out.length ? out : products.slice();
  }

  function openBuilder(opts) {
    if (!modal) return;
    state.lastFocus = document.activeElement;
    state.bundle = opts;
    state.selection = {};
    renderBuilder();
    modal.classList.add("is-open");
    if (modalOverlay) modalOverlay.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    state.open = true;
    var c = modal.querySelector(".wc-modal__close"); if (c) c.focus();
  }
  function closeBuilder() {
    if (!modal || !state.open) return;
    modal.classList.remove("is-open");
    if (modalOverlay) modalOverlay.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    state.open = false;
    if (state.lastFocus) state.lastFocus.focus();
  }

  function selectedCount() {
    var n = 0; Object.keys(state.selection).forEach(function (k) { n += state.selection[k]; }); return n;
  }

  function renderBuilder() {
    var b = state.bundle;
    var list = eligibleProducts(b.handles);
    // in-stock teams first, sold-out at the end
    list = list.slice().sort(function (a, x) {
      return (stockOf(a.variantId) <= 0 ? 1 : 0) - (stockOf(x.variantId) <= 0 ? 1 : 0);
    });
    modal.querySelector("[data-wc-bb-title]").textContent = "Build Your " + b.title;
    modal.querySelector("[data-wc-bb-sub]").textContent = "Choose " + b.qty + " mugs from any teams.";
    var grid = modal.querySelector("[data-wc-bb-grid]");
    grid.innerHTML = "";
    list.forEach(function (p) {
      var qty = state.selection[p.variantId] || 0;
      var stock = stockOf(p.variantId);
      var sold = stock <= 0;
      var low = !sold && stock <= 5;
      var card = document.createElement("div");
      card.className = "wc-pick" + (qty > 0 ? " is-selected" : "") + (sold ? " is-soldout" : "");
      card.setAttribute("data-variant", p.variantId);
      card.innerHTML =
        '<div class="wc-pick__media"><img src="' + (p.image || "") + '" alt="' + escapeHtml(p.title) + '" loading="lazy"></div>' +
        '<div class="wc-pick__name">' + escapeHtml(p.shortName || p.title) + '</div>' +
        (sold ? '<div class="wc-pick__stock wc-pick__stock--out">Sold out</div>'
              : (low ? '<div class="wc-pick__stock">Only ' + stock + ' left</div>' : '')) +
        '<div class="wc-stepper">' +
          '<button type="button" data-bb-minus aria-label="Remove one ' + escapeHtml(p.title) + '"' + (qty <= 0 ? " disabled" : "") + '>&minus;</button>' +
          '<span class="wc-stepper__val" data-bb-val>' + qty + '</span>' +
          '<button type="button" data-bb-plus aria-label="Add one ' + escapeHtml(p.title) + '"' + (sold || qty >= stock ? " disabled" : "") + '>+</button>' +
        '</div>';
      grid.appendChild(card);
    });
    updateBuilderProgress();
  }

  function updateBuilderProgress() {
    var b = state.bundle, total = b.qty, count = selectedCount();
    modal.querySelector("[data-wc-bb-progress]").textContent = count + " / " + total + " mugs selected";
    var remaining = total - count;
    var rEl = modal.querySelector("[data-wc-bb-remaining]");
    rEl.textContent = remaining > 0 ? ("Select " + remaining + " more mug" + (remaining > 1 ? "s" : ""))
                     : (count > total ? "Remove " + (count - total) : "Bundle complete ✓");
    var fill = modal.querySelector(".wc-progressbar__fill");
    if (fill) fill.style.width = Math.min(100, (count / total) * 100) + "%";
    // summary
    var parts = [];
    Object.keys(state.selection).forEach(function (vid) {
      if (state.selection[vid] > 0) {
        var p = productByVariant[vid];
        parts.push((p ? (p.shortName || p.title) : "Mug") + " x" + state.selection[vid]);
      }
    });
    modal.querySelector("[data-wc-bb-summary]").textContent = parts.join(", ");
    var addBtn = modal.querySelector("[data-wc-bb-add]");
    var ok = count === total;
    addBtn.disabled = !ok;
    addBtn.querySelector("[data-bb-addlabel]").textContent = "Add Bundle to Cart · " + money(b.price);
  }

  if (modal) {
    modal.addEventListener("click", function (e) {
      var plus = e.target.closest("[data-bb-plus]");
      var minus = e.target.closest("[data-bb-minus]");
      if (!plus && !minus) return;
      var card = e.target.closest(".wc-pick");
      var vid = card.getAttribute("data-variant");
      var b = state.bundle;
      var cur = state.selection[vid] || 0;
      var count = selectedCount();
      if (plus) {
        if (count >= b.qty) { return; }
        if (!b.allowDup && cur >= 1) { toast("Duplicate teams aren’t allowed in this bundle.", "error"); return; }
        var stk = stockOf(vid);
        if (cur >= stk) {
          toast(stk <= 0 ? "This team is sold out." : "Only " + stk + " left in stock for this team.", "error");
          return;
        }
        state.selection[vid] = cur + 1;
      } else if (minus) {
        if (cur > 0) state.selection[vid] = cur - 1;
      }
      // update just this card + progress
      var qty = state.selection[vid] || 0;
      card.classList.toggle("is-selected", qty > 0);
      card.querySelector("[data-bb-val]").textContent = qty;
      card.querySelector("[data-bb-minus]").disabled = qty <= 0;
      // refresh plus disabled states across grid (full bundle, duplicates, or stock cap)
      var full = selectedCount() >= b.qty;
      modal.querySelectorAll(".wc-pick").forEach(function (c) {
        var pBtn = c.querySelector("[data-bb-plus]");
        var cvid = c.getAttribute("data-variant");
        var cv = state.selection[cvid] || 0;
        var dupBlock = !b.allowDup && cv >= 1;
        pBtn.disabled = full || dupBlock || cv >= stockOf(cvid);
      });
      updateBuilderProgress();
    });

    var addBtn = modal.querySelector("[data-wc-bb-add]");
    addBtn.addEventListener("click", function () {
      var b = state.bundle;
      if (selectedCount() !== b.qty) return;
      if (addBtn.dataset.loading === "1") return;
      var teams = [];
      var comps = [];
      Object.keys(state.selection).forEach(function (vid) {
        if (state.selection[vid] > 0) {
          var p = productByVariant[vid];
          teams.push((p ? (p.shortName || p.title) : "Mug") + " x" + state.selection[vid]);
          comps.push(vid + ":" + state.selection[vid]);
        }
      });
      var props = {};
      props["Bundle"] = b.title + " (" + b.qty + " mugs)";
      props["Selected Teams"] = teams.join(", ");
      props["Total Mugs"] = String(b.qty);
      props["_Components"] = comps.join(",");
      if (b.perLabel) props["Price"] = b.perLabel;
      var item = { id: Number(b.variantId), quantity: 1, properties: props };
      setBtnLoading(addBtn, true);
      addToCart([item])
        .then(function () {
          refreshCartCount();
          closeBuilder();
          toast(b.title + MSG_ADDED_SUFFIX, "success", true);
        })
        .catch(function () { toast("Couldn’t add the bundle. Please try again.", "error"); })
        .finally(function () { setBtnLoading(addBtn, false); });
    });

    modal.querySelectorAll("[data-wc-bb-close]").forEach(function (b) { b.addEventListener("click", closeBuilder); });
    if (modalOverlay) modalOverlay.addEventListener("click", closeBuilder);
  }

  /* ---------- Bundle CTA triggers ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-wc-bundle-open]");
    if (!btn) return;
    e.preventDefault();
    var mode = btn.getAttribute("data-wc-bundle-mode") || "builder";
    if (mode === "scroll") {
      scrollToId(btn.getAttribute("data-wc-bundle-scroll") || "wc-top-teams");
      return;
    }
    if (mode === "single") {
      // add the single mug bundle by scrolling to teams (user picks 1) OR direct add not applicable
      scrollToId(btn.getAttribute("data-wc-bundle-scroll") || "wc-top-teams");
      return;
    }
    var variantId = btn.getAttribute("data-wc-bundle-variant");
    if (!variantId) { toast("This bundle isn’t set up yet.", "error"); return; }
    openBuilder({
      title: btn.getAttribute("data-wc-bundle-title") || "Bundle",
      qty: Number(btn.getAttribute("data-wc-bundle-qty") || "2"),
      variantId: variantId,
      price: Number(btn.getAttribute("data-wc-bundle-price") || "0"),
      perLabel: btn.getAttribute("data-wc-bundle-per") || "",
      allowDup: btn.getAttribute("data-wc-bundle-allow-dup") !== "false",
      handles: btn.getAttribute("data-wc-bundle-handles") || ""
    });
  });

  /* ---------- Global keydown: ESC ---------- */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeBuilder(); closeDrawer(); }
    if (e.key === "Tab" && state.open && modal) trapFocus(e, modal);
    if (e.key === "Tab" && drawer && drawer.classList.contains("is-open")) trapFocus(e, drawer);
  });
  function trapFocus(e, container) {
    var f = container.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* ---------- init ---------- */
  refreshCartCount();
})();
